<template>
    <div>
        <!-- external chips -->
        <div class="company-files mb-2">
            <v-chip
                v-for="(f, i) in fileList"
                :key="f.name + i"
                class="me-2 mb-2"
                color="primary"
                small
                closable
                @click:close="removeFile(i)"
            >
                {{ f.name }}
            </v-chip>
        </div>

        <!-- the actual file input: shows comma‐separated names inside the field -->
        <v-file-input
            v-model="fileList"
            :label="label"
            :multiple="true"
            show-size
            :accept="accept"
            :rules="[minRule]"
            clearable
        >
        </v-file-input>
    </div>
</template>

<script>
export default {
    name: "FileUploader",
    props: {
        modelValue: {
            type: Array,
            default: () => [],
        },
        minFiles: { type: Number, default: 1 },
        label: { type: String },
        accept: { type: String, default: "" }, // e.g. ".pdf,.png"
        clearable: { type: Boolean, default: false },
    },
    emits: ["update:modelValue"],
    computed: {
        // proxy so v-file-input reads & writes this, but we merge new picks rather than overwrite
        fileList: {
            get() {
                return this.modelValue;
            },
            set(picked) {
                // clear case
                if (!picked || picked.length === 0) {
                    this.$emit("update:modelValue", []);
                    return;
                }
                // merge newly-picked files into the existing array
                const existing = [...this.modelValue];
                const list = Array.isArray(picked) ? picked : [picked];
                list.forEach((f) => {
                    if (!existing.find((x) => x.name === f.name)) {
                        existing.push(f);
                    }
                });
                this.$emit("update:modelValue", existing);
            },
        },
        // built-in min-files rule
        minRule() {
            return (files) => {
                const count = files?.length || 0;
                if (count >= this.minFiles) return true;

                // if exactly 4 are required, use the special key:
                if (this.minFiles === 4) {
                    return this.$t("validation.fourFilesRequired");
                }

                // otherwise fall back to the generic “minFiles” key:
                return this.$t("validation.insufficientDocuments", {
                    n: this.minFiles,
                });
            };
        },
    },
    methods: {
        removeFile(idx) {
            const arr = [...this.modelValue];
            arr.splice(idx, 1);
            this.$emit("update:modelValue", arr);
        },
    },
};
</script>
